

















import Vue from 'vue';
import dayjs from 'dayjs';
import ApparatLogo from '@/assets/figma/LOGO/APPARAT ENKEL.svg';
import { isScreenSM } from '@/utils/breakpoints';
import Footer from './Footer.vue';
import 'dayjs/locale/nb';

dayjs.locale('nb');

export default Vue.extend({
  name: 'App',
  components: {
    Footer,
    ApparatLogo,
  },
  data() {
    return {
      isMobile: false,
      isHomeScreen: false,
    };
  },
  created() {
    this.setIsMobile();
    this.setIsHomeScreen();
  },
  watch: {
    $windowWidth() {
      this.setIsMobile();
    },
    $route() {
      this.setIsHomeScreen();
    },
  },
  methods: {
    setIsMobile() {
      this.isMobile = isScreenSM(this.$windowWidth);
    },
    setIsHomeScreen() {
      this.isHomeScreen = this.$route.path === '/';
    },
  },
});
